import script from "./HrDataLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDataLabel.vue?vue&type=script&setup=true&lang=js"

import "./HrDataLabel.vue?vue&type=style&index=0&id=5c8d5f30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c8d5f30"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});qInstall(script, 'directives', {Ripple});
